// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wlne","question":"styles_question__35GTO","inputVisibleButton":"styles_inputVisibleButton__2_aF8","note":"styles_note__1r5Fv"};